const VERSION_FORMAT = /^\d+\.\d+$/

export const isValidVersionFormat = (v) => typeof v === 'string' && VERSION_FORMAT.test(v)

export const parseVersion = (v) => {
  if (!isValidVersionFormat(v)) return null
  const [major, minor] = v.split('.').map(Number)
  return [major, minor]
}

export const compareVersions = (a, b) => {
  const ta = parseVersion(a)
  const tb = parseVersion(b)
  if (!ta || !tb) return 0
  if (ta[0] !== tb[0]) return ta[0] - tb[0]
  return ta[1] - tb[1]
}

export const getMaxVersion = (versions) => {
  let max = null
  for (const v of versions) {
    const t = parseVersion(v)
    if (!t) continue
    if (max == null || compareVersions(v, max) > 0) max = v
  }
  return max
}

export const nextVersion = (v) => {
  const t = parseVersion(v)
  if (!t) return null
  const [major, minor] = t
  if (minor >= 9) return `${major + 1}.0`
  return `${major}.${minor + 1}`
}

export const suggestNextVersion = (versions) => {
  const max = getMaxVersion(versions)
  if (!max) return '1.0'
  return nextVersion(max) || ''
}
